import PrintRosterContainer from './PrintRosterContainer';
import { handlePrintRosterRouteEnter } from './PrintRoster.saga';

export default {
  path: '/venues/:venueId/schedules/:scheduleId/roster/print',
  component: PrintRosterContainer,
  pathSagas: [handlePrintRosterRouteEnter],
};
